module.exports = __webpack_public_path__ + "img/490687b.png";